import type { GuideType } from '@/modules/ConfiguratorJoints/composables/useGuidesAndType';
import type { JointCanvasTemplateConfiguration } from '@/modules/ConfiguratorJoints/types/canvasTemplate';
import type {
    GuideImageSlot,
    RegularGuideSlot,
    RenderedGuideType,
} from '@/modules/ConfiguratorJoints/types/jointsConfiguratorTemplate';

export function resolveCornerJointGuideAsset(
    template: JointCanvasTemplateConfiguration,
    slot: RegularGuideSlot,
    guideType: GuideType | null
) {
    if (!guideType || guideType === 'no-guide' || !template.guides) {
        return null;
    }

    let renderedGuideType: RenderedGuideType = 'regular';
    let imageSlot: GuideImageSlot = slot;

    if (guideType === 'wire-guide') {
        renderedGuideType = 'wireGuide';
        imageSlot = 'wireGuide';
    } else if (guideType === 'inox-guide') {
        renderedGuideType = 'inoxGuide';
        imageSlot = 'inoxGuide';
    } else if (guideType === 'concealed-guide') {
        renderedGuideType = 'concealedGuide';
        imageSlot = slot.endsWith('Top') ? 'concealedGuideTop' : 'concealedGuideBottom';
    }

    const asset = renderedGuideType === 'regular' ? template.guides[slot] : template.guides[imageSlot];

    return asset ? { asset, imageSlot, renderedGuideType } : null;
}
